import React from 'react';
import PropTypes from 'prop-types';
import Scrollspy from 'react-scrollspy';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import classNames from 'classnames';
import { values, isEmpty, partition, times } from 'lodash';
import { getSurveyStartSection } from 'selectors';
import { ASQLogos, STICKY_HEIGHT } from 'utils/Formatters';

const answerCircle = (asq, entities, responses) => {
  return responses.map( (r, i) => {
    const answer = r.answer ? entities.answers[r.answer] : null;
    const clsAnswer = classNames('o-sidebar-section__answer', {
      'o-sidebar-section__answer--base': !answer,
      [`o-sidebar-section__answer--${asq.type}`]: answer,
    });
    return <span key={`nav-${r.id}-${i}`} className={clsAnswer}></span>;
  });
}

export default class ASQSidebar extends React.PureComponent {
  static propTypes = {
    survey: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const startSection = getSurveyStartSection(this.props.survey);
    if (startSection > 1) {
      window.scroll({
        top: document.getElementById(`section-${startSection}`).offsetTop - STICKY_HEIGHT,
      })
    }
  }

  render() {
    const { survey } = this.props;
    if (isEmpty(survey)) return null;
    const entities = survey.entities;
    const asq = entities.surveys[survey.result];
    const sections = entities.questionnaires[asq.questionnaire].sections.map( (sKey, idx) => {
      const s = entities.sections[sKey];
      const answers = s.questions.map( q => {
        const responses = entities.questions[q].responseTypes.map(i => entities.responseTypes[i]);
        const [ required, optional ] = partition(responses, 'required');
        return required.length ? answerCircle(asq, entities, required) : answerCircle(asq, entities, optional);
      });
      return (
        <div key={`nav-${idx}`} className='o-sidebar__section u-margin-top--base'>
          <AnchorLink className='cs-txt-link--sp-black u-txt--survey-title' href={`#section-${idx + 1}`} offset={STICKY_HEIGHT}>
            {s.name}
          </AnchorLink>
          <div className='o-sidebar-section__answers'>{answers}</div>
        </div>
      )
    })
    const sectionAnchors = times(values(entities.sections).length, i => `section-${i + 1}`);
    return (
      <div className='u-margin-top--large u-margin-bottom--base'>
        <div className='o-sidebar__logo'>
          <img alt={asq.type} src={ASQLogos[asq.type]} />
        </div>
        <Scrollspy items={ sectionAnchors }
          currentClassName={`cs-txt-link--${asq.type}`}
          offset={-STICKY_HEIGHT}
          componentTag={'nav'}>
          {sections}
        </Scrollspy>
      </div>
    );
  }
}
